import { createContext, useContext, useState } from 'react';

const AuthContext = createContext();

export function AuthProvider({ children }) {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [adminName, setAdminName] = useState('');

    const login = (name) => {
        setIsAuthenticated(true);
        setAdminName(name || '');
    };

    const logout = () => {
        setIsAuthenticated(false);
        setAdminName('');
    };

    return (
        <AuthContext.Provider value={{ isAuthenticated, adminName, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
